var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('v-card',[_c('div',{style:(_vm.inlineStyle),attrs:{"row":"","justify-center":"","align-center":"","id":"export"},domProps:{"innerHTML":_vm._s(_vm.template.text)}}),_vm._v(" "),_c('div',{staticClass:"px-3 text-xs-center"},[_c('v-btn',{attrs:{"color":"info"},on:{"click":_vm.exportToPDF}},[_vm._v("Exportar a PDF")])],1)])],1)}
var staticRenderFns = []
module.exports = { render: render, staticRenderFns: staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-03057b35","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/pages/school/services/digital_document.vue
// module id = Kvh1
// module chunks = 2